/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignMassMessageRequest } from '../models/AssignMassMessageRequest';
import type { OnlyFansMassMessageStatsResponse } from '../models/OnlyFansMassMessageStatsResponse';
import type { QueueEntry } from '../models/QueueEntry';
import type { ScheduledMessage } from '../models/ScheduledMessage';
import type { SendMassMessageRequest } from '../models/SendMassMessageRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfMassMessagesService {
    /**
     * Send a mass message
     * Sends a mass message to multiple users based on excludedLists, userLists and filters
     * @returns ScheduledMessage OK
     * @throws ApiError
     */
    public static sendMassMessage({
        creatorId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * JSON payload containing the message content and metadata.
         */
        requestBody: SendMassMessageRequest,
    }): CancelablePromise<ScheduledMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/massMessage',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static chatMassMessageRestControllerAssignMassMessageSender({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: AssignMassMessageRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/massMessage/assign',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all filtered scheduled messages.
     * Retrieves a filtered list of scheduled messages for the specific creator within the time.
     * @returns ScheduledMessage OK
     * @throws ApiError
     */
    public static getScheduledMessages({
        creatorId,
        start,
        end,
        filterArray,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * Start of the filter.
         */
        start: string,
        /**
         * End of the filter.
         */
        end: string,
        /**
         * filter[]=post and/or filter[]=chat
         */
        filterArray: Array<string>,
    }): CancelablePromise<Array<ScheduledMessage>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/scheduled',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'start': start,
                'end': end,
                'filter[]': filterArray,
            },
        });
    }
    /**
     * Get queued messages
     * Retrieves the queued messages for a specific user and creator.
     * @returns QueueEntry Queued messages retrieved successfully
     * @throws ApiError
     */
    public static getQueuedMessages({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<Array<QueueEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/queue',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Export mass message stats as CSV
     * Exports mass message statistics for a specific creator in CSV format from the last 14 days.
     * @returns binary CSV file containing the mass message statistics.
     * @throws ApiError
     */
    public static exportMassMessagesStats({
        creatorId,
        accept = 'text/csv',
    }: {
        /**
         * Unique identifier of the creator whose stats are being exported.
         */
        creatorId: number,
        /**
         * Expected response format. Defaults to `text/csv`.
         */
        accept?: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/massMessage/stats/export',
            path: {
                'creatorId': creatorId,
            },
            headers: {
                'Accept': accept,
            },
            errors: {
                401: `Unauthorized. The user must be authenticated.`,
                404: `Creator not found or access denied.`,
            },
        });
    }
    /**
     * Get paginated mass message stats
     * Request paginated mass message stats from OnlyFans
     * @returns OnlyFansMassMessageStatsResponse Object containing the stats. The format is equal to the result of /users/me/stats/messages/group in the OnlyFans API + sender ids
     * @throws ApiError
     */
    public static getMassMessages({
        creatorId,
        endDate,
        offset,
        query,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * End date for pagination (ISO-8601 format). For pagination, use the oldest message date from the previous response. Defaults to now if not provided.
         */
        endDate?: string,
        offset?: number,
        query?: string,
    }): CancelablePromise<OnlyFansMassMessageStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/mass-message/stats',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'endDate': endDate,
                'offset': offset,
                'query': query,
            },
        });
    }
    /**
     * Delete a mass message
     * Deleting will delete the messages for everybody that has not opened the message yet
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMassMessage({
        creatorId,
        massMessageId,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the mass message.
         */
        massMessageId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/of-chat/{creatorId}/massMessage/{massMessageId}',
            path: {
                'creatorId': creatorId,
                'massMessageId': massMessageId,
            },
        });
    }
}
